import React from 'react'
import { PrescriptorInstallersDashboard } from '../../features/prescriptor-installers'

export const PrescriptorInstallersPage = () => <PrescriptorInstallersDashboard />
